const getters = {
  userId: state => state.user.userId,
  email: state => state.user.email,
  password: state => state.user.password,
}
export default getters
